import StudentAppSection from './StudentAppSection';
import { StudentAppSectionProps, StudentAppSectionValueProps } from './types';

export type { StudentAppSectionProps, StudentAppSectionValueProps };
export default StudentAppSection;
